module.exports = __webpack_public_path__ + "media/markers/powerb_yel-7781abcb.svg";